import { Button } from "@/components/Button";
import { Reveal } from "@/components/Reveal";

type CtaBandProps = {
  title?: string;
  body?: string;
};

export function CtaBand({
  title = "See ServiTrex run a real home-service day",
  body = "Walk the office board, TrexField job flow, and AI voice intake with a specialist who knows HVAC, plumbing, electrical, and roofing operations.",
}: CtaBandProps) {
  return (
    <section className="py-10 sm:py-14">
      <div className="container-page">
        <Reveal>
          <div className="relative overflow-hidden rounded-[2rem] border border-border bg-ink px-6 py-10 text-fg-inverse shadow-soft sm:px-10 sm:py-12 lg:px-14">
            <div
              aria-hidden
              className="pointer-events-none absolute -right-16 -top-20 h-64 w-64 rounded-full bg-teal/20 blur-3xl"
            />
            <div
              aria-hidden
              className="pointer-events-none absolute -bottom-24 left-10 h-56 w-56 rounded-full bg-accent-warm/15 blur-3xl"
            />
            <div className="relative grid items-end gap-8 lg:grid-cols-[1.4fr_auto]">
              <div>
                <p className="text-xs font-semibold uppercase tracking-[0.18em] text-teal">
                  Next step
                </p>
                <h2 className="mt-3 max-w-2xl text-balance text-3xl sm:text-4xl">{title}</h2>
                <p className="mt-4 max-w-xl text-pretty text-base text-fg-inverse/70 sm:text-lg">
                  {body}
                </p>
              </div>
              <div className="flex flex-wrap gap-3">
                <Button to="/demo" size="lg">
                  Book a demo
                </Button>
                <Button to="/signup" variant="secondary" size="lg" className="border-white/15 bg-white/5 text-fg-inverse hover:bg-white/10">
                  Compare plans
                </Button>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
